import axiosInstance from '../utils/axios';

/**
 * 공지사항 관련 API 서비스
 */
class NoticeService {
  /**
   * 공지사항 목록을 조회합니다.
   * 
   * @param {number} pageSize 페이지 크기
   * @param {number} page 페이지 번호
   * @returns {Promise<Object>} 공지사항 목록
   */
  async getNoticeList(pageSize = 10, page = 1) {
    try {
      const response = await axiosInstance.get('/notice/list', {
        params: {
          pageSize,
          page
        }
      });

      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data
        };
      }
      
      return {
        success: false,
        message: response.data.message || '공지사항 목록을 불러오는데 실패했습니다.'
      };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || '공지사항 목록을 불러오는 중 오류가 발생했습니다.';
      return {
        success: false,
        message: errorMessage
      };
    }
  }

  /**
   * 공지사항 상세 정보를 조회합니다.
   * 
   * @param {number} id 공지사항 ID
   * @returns {Promise<Object>} 공지사항 상세 정보
   */
  async getNoticeDetail(id) {
    try {
      const response = await axiosInstance.get(`/notice/${id}`);
      
      if (response.data.success && response.data.data) {
        return {
          success: true,
          data: response.data.data
        };
      }
      
      return {
        success: false,
        message: response.data.message || '공지사항을 찾을 수 없습니다.'
      };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || '공지사항을 불러오는 중 오류가 발생했습니다.';
      return {
        success: false,
        message: errorMessage
      };
    }
  }

  /**
   * 새로운 공지사항을 생성합니다.
   * 
   * @param {Object} noticeData 공지사항 데이터
   * @returns {Promise<Object>} 생성 결과
   */
  async createNotice(noticeData) {
    try {
      const response = await axiosInstance.post('/notice', noticeData);

      if (response.data.success) {
        return {
          success: true,
          data: response.data.data
        };
      }
      
      return {
        success: false,
        message: response.data.message || '공지사항 등록에 실패했습니다.'
      };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || '공지사항을 등록하는 중 오류가 발생했습니다.';
      return {
        success: false,
        message: errorMessage
      };
    }
  }

  /**
   * 공지사항을 수정합니다.
   * 
   * @param {number} id 공지사항 ID
   * @param {Object} noticeData 수정할 공지사항 데이터
   * @returns {Promise<Object>} 수정 결과
   */
  async updateNotice(id, noticeData) {
    try {

      const response = await axiosInstance.put(`/notice/${id}`, noticeData);

      if (response.data.success) {
        return {
          success: true,
          data: response.data.data
        };
      }
      
      return {
        success: false,
        message: response.data.message || '공지사항 수정에 실패했습니다.'
      };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || '공지사항을 수정하는 중 오류가 발생했습니다.';
      return {
        success: false,
        message: errorMessage
      };
    }
  }

  /**
   * 공지사항을 삭제합니다.
   * 
   * @param {Array} ids 삭제할 공지사항 ID 배열
   * @returns {Promise<Object>} 삭제 결과
   */
  async deleteNotices(ids) {
    try {
      const response = await axiosInstance.delete('/notice/batch', {
        data: {
          noticeIds: ids
        }
      });

      if (response.data.success) {
        return {
          success: true,
          message: response.data.message || '공지사항이 성공적으로 삭제되었습니다.'
        };
      }
      
      return {
        success: false,
        message: response.data.message || '공지사항 삭제에 실패했습니다.'
      };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || '공지사항을 삭제하는 중 오류가 발생했습니다.';
      return {
        success: false,
        message: errorMessage
      };
    }
  }
}

export default new NoticeService();
